import { useMemo, useState } from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";

import { useGetPermission } from "@hooks/useGetPermission";

import { ParametricosProvider } from "../context/ParametricosContext";
import DatosParametricos from "../components/sections/DatosParametricos";
import ProyeccionParametricos from "../components/sections/ProyeccionParametricos";

type ParametricosTab = "datos" | "proyeccion";

interface TabConfig {
    value: ParametricosTab;
    label: string;
    module: "SBPADAT" | "SBPAPRO";
}

const TABS: TabConfig[] = [
    { value: "datos", label: "Datos", module: "SBPADAT" },
    { value: "proyeccion", label: "Proyección", module: "SBPAPRO" },
];

export default function Parametricos() {
    const [tab, setTab] = useState<ParametricosTab>("datos");

    const permissions = useGetPermission("MPAMET");

    const visibleTabs = useMemo(() => {
        if (permissions === undefined) return TABS;

        const availableModules = new Set(
            permissions.children.filter((child) => child.can_watch).map((child) => child.code),
        );
        return TABS.filter((tabConfig) => availableModules.has(tabConfig.module));
    }, [permissions]);

    const currentTab = visibleTabs.some((tabConfig) => tabConfig.value === tab) ? tab : visibleTabs[0]?.value;

    return (
        <Box sx={{ py: 2 }}>
            <Box sx={{ mb: 2.25 }}>
                <Typography sx={{ typography: "h4", fontSize: "1.125rem", color: "text.primary" }}>
                    Paramétricos
                </Typography>
                <Typography
                    sx={{ typography: "body2", fontSize: "0.75rem", color: "text.secondary", mt: 0.25, maxWidth: 620 }}
                >
                    Paramétricos
                </Typography>
            </Box>

            <Tabs
                value={currentTab ?? "datos"}
                onChange={(_event, value) => setTab(value)}
                variant="fullWidth"
                sx={{ mb: 2.5 }}
            >
                {visibleTabs.map((tabConfig) => (
                    <Tab key={tabConfig.value} value={tabConfig.value} label={tabConfig.label} />
                ))}
            </Tabs>

            <ParametricosProvider>
                <Box sx={{ display: currentTab === "datos" ? "block" : "none" }}>
                    <DatosParametricos />
                </Box>
                <Box sx={{ display: currentTab === "proyeccion" ? "block" : "none" }}>
                    <ProyeccionParametricos />
                </Box>
            </ParametricosProvider>
        </Box>
    );
}
